const API_BASE = import.meta.env.VITE_API_BASE || '/api';
const ADMIN_API = `${API_BASE}/portal`;

export interface PricingTierConfig {
  min: number;
  max: number | null;
  rate: number;
  label: string;
  sortOrder: number;
}

function getAuthHeaders(token?: string | null): HeadersInit {
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export async function getPricingConfig(token?: string | null): Promise<PricingTierConfig[]> {
  const response = await fetch(`${ADMIN_API}/pricing`, {
    method: 'GET',
    headers: getAuthHeaders(token),
  });

  if (!response.ok) {
    throw new Error(`Failed to load pricing config: HTTP ${response.status}`);
  }

  const data = await response.json();
  return Array.isArray(data?.tiers) ? data.tiers : [];
}

export async function updatePricingConfig(tiers: PricingTierConfig[], token?: string | null): Promise<PricingTierConfig[]> {
  const response = await fetch(`${ADMIN_API}/pricing`, {
    method: 'PUT',
    headers: getAuthHeaders(token),
    body: JSON.stringify({ tiers }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data?.error || `Failed to update pricing config: HTTP ${response.status}`);
  }

  return Array.isArray(data?.tiers) ? data.tiers : tiers;
}
